// src/pages/Courses.jsx
import React, { useEffect } from 'react';
import CoursesHero from '../components/courses/CoursesHero';
import SpecializationHighlight from '../components/courses/SpecializationHighlight';
import CourseList from '../components/courses/CourseList';
import CtaBanner from '../components/includes/CtaBanner';
import CompanyLogosSlider from '../components/includes/CompanyLogosSlider'; // If you want to reuse it here
import '../styles/globals.css'; // Your global styles

const Courses = () => {
  // Use useEffect to set the page title when the component loads
  useEffect(() => {
    document.title = "Top Trending Courses in Chennai | Bspark Software Technologies";
  }, []); // The empty dependency array ensures this runs only once

  return (
    <div className="courses-page-wrapper">
      <CoursesHero />
      <SpecializationHighlight />
      <CourseList />
      <CompanyLogosSlider />
      <CtaBanner
        title="Ready to Transform Your Career?"
        subtitle="Our expert advisors are here to guide you. Book a free counseling session today!"
        buttonText="Get Free Counseling"
        buttonLink="/contact"
      />
    </div>
  );
};

export default Courses;